/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnvironmentService } from '../service/service.module';
import { LocalstorageService } from '../config/localstorage.service'
import { USER_ROLES, USER_TEAMS, RETAILER_TEAM_CODE, VENDOR_TEAM_CODE, BEST_BUY_ROLE_CODE, INVALID_TEAM, USER_TOKEN_INFO } from '@algomusinc/domain';
import _ from 'lodash';
import { jwtDecode } from 'jwt-decode';

@Injectable({ providedIn: 'root' })
export class UsersService {
  environment = EnvironmentService.environment;
  claimGroupList: any[] = [];
  listUpdate = new BehaviorSubject<boolean>(false);
  listUpdate$ = this.listUpdate.asObservable();
  public changeTenants = new EventEmitter<any>();
  constructor(private http: HttpClient, public storage: LocalstorageService) {
  }
  CreateUser(user: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppAccount as string}/createuser`,
      user
    );
  }

  UpdateUser(user: any): Observable<any> {
    return this.http.post(`${this.environment.AppAccount as string}/update`, user);
  }
  ActivateUser(user: any): Observable<any> {
    return this.http.put(`${this.environment.AppAccount as string}/activate`, user);
  }
  GetUserById(userId: string): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppAccount as string}/getUserById?UserId=${userId}`,
      {}
    );
  }

  SearchUser(ch: string): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppAccount as string}/search?search=${ch}`,
      {}
    );
  }
  GetAllUsers(params: any): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    return this.http.get<any>(`${this.environment.AppAccount as string}/getall`, { params });
  }
  GetUserRolesList(): Observable<any> {
    return this.http.get(`${this.environment.AppRole as string}/getlist`);
  }

  GetUserRolesAll(): Observable<any> {
    return this.http.get(`${this.environment.AppRole as string}/getall`);
  }

  CreateRole(role: any): Observable<any> {
    return this.http.post<any>(`${this.environment.AppRole as string}/add`, role);
  }

  UpdateRole(role: any): Observable<any> {
    return this.http.put(`${this.environment.AppRole as string}/update`, role);
  }
  UpdateUserLock(role: any): Observable<any> {
    return this.http.put(
      `${this.environment.AppAccount as string}/updateUserLocked`,
      role
    );
  }
  ActivateRole(role: any): Observable<any> {
    return this.http.put(`${this.environment.AppRole as string}/activate`, role);
  }
  GetRoleById(roleId: string): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppRole as string}/get?RoleId=${roleId}`,
      {}
    );
  }

  SearchUsers(ch: string): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppAccount as string}/search?search=${ch}`,
      {}
    );
  }

  getClaimsByRole(RoleId: string | number): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppRole as string}/get?RoleId=${RoleId}`,
      {}
    );
  }

  GetUserByEmail(email: string): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppAccount as string}/getUserByEmail?Email=${email}`,
      {}
    );
  }
  getClaimByCurrentUser(id: string | number): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppClaimGroup as string}/getAllByUser?CurrentUserId=${id}`,
      {}
    );
  }
  getTeams(): Observable<any> {
    return this.http.get(`${this.environment.AppTeams as string}/getlist`);
  }
  CreateTeam(team: any): Observable<any> {
    return this.http.post<any>(`${this.environment.AppTeams as string}/add`, team);
  }
  GetTeamById(teamId: string): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppTeams as string}/get?TeamId=${teamId}`,
      {}
    );
  }
  UpdateTeam(team: any): Observable<any> {
    return this.http.put(`${this.environment.AppTeams as string}/update`, team);
  }
  ActivateTeam(team: any): Observable<any> {
    return this.http.put(`${this.environment.AppTeams as string}/activate`, team);
  }
  DeleteTeam(team: any): Observable<any> {
    return this.http.put(`${this.environment.AppTeams as string}/delete`, team);
  }
  AddUserRole(team: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppAccount as string}/AddUserRole`,
      team
    );
  }
  AddUserTeam(team: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppAccount as string}/AddUserTeam`,
      team
    );
  }
  UserTenantsAddBulk(tenants: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppTenant}/UserTenantsAddBulk`,
      tenants
    );
  }
  UserWiseTenantsAddBulk(tenants: any): Observable<any> {
    return this.http.post<any>(
      `${this.environment.AppTenant}/UserWiseTenantsAddBulk`,
      tenants
    );
  }
  GetTenants(params: any) {
    return this.http.get<any>(`${this.environment.AppTenant}/TenantsGetList`, { params })
  }
  TenantsGetAll() {
    return this.http.get<any>(`${this.environment.AppTenant}/TenantsGetAll`)
  }
  UpdateTenants(tenants: any): Observable<any> {
    return this.http.put(`${this.environment.AppTenant}/TenantsUpdate`, tenants);
  }
  TenantsActivate(tenants: any): Observable<any> {
    return this.http.put(`${this.environment.AppTenant}/TenantsActivate`, tenants);
  }
  GetPostAuthenticationToken(tenantId: any): Observable<any> {
    return this.http.get(`${this.environment.AppAccount}/getPostAuthenticationToken?tenantId=${tenantId}`);
  }
  GetEmailBySubjectId(): Observable<any> {
    return this.http.get<any>(
      `${this.environment.AppAccount as string}/getEmailBySubjectId`,
      {}
    );
  }
  getUserWithClient() {
    return this.http.get(`${this.environment.AppTenant}/GetUsersWithTenants?offSet`);
  }
  /**
  * Updates the assigned clients of a user.
  * 
  * @param userId - The user id.
  * @param clients - List of clients: [{clientConfigurationId: number, isAssigned: boolean}]
  * 
  */
  updateUserWithClientList(payload: { userId: number, clients: Array<{ clientConfigurationId: number, isAssigned: boolean }> }) {
    return this.http.post(`${this.environment.AppTenant}/UpdateUserTenantList`, payload);
  }

  /*
*   This method will return Team code of Login User
*/
  checkLoginUserTeam() {
    const roles = this.storage.get(USER_ROLES);
    const teams = this.storage.get(USER_TEAMS);
    const isRetailer = _.find(teams, a => a.teamNameCode === RETAILER_TEAM_CODE);
    const isVendor = _.find(teams, a => a.teamNameCode === VENDOR_TEAM_CODE);
    const isBestBuyRole = _.find(roles, a => a.roleCode === BEST_BUY_ROLE_CODE);
    if (isRetailer) {
      return isBestBuyRole ? RETAILER_TEAM_CODE : INVALID_TEAM;
    } else if (isVendor) {
      return isBestBuyRole ? INVALID_TEAM : VENDOR_TEAM_CODE;
    } else {
      return INVALID_TEAM;
    }
  }

  getTeamRoleAccount(): any {
    const token = this.storage.get(USER_TOKEN_INFO);
    try {
      const tokenData: any = jwtDecode(token);
      return Number(tokenData.AccountId);
    } catch (Error) {
      return null;
    }
  }

}
